(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Web3Modal", [], factory);
	else if(typeof exports === 'object')
		exports["Web3Modal"] = factory();
	else
		root["Web3Modal"] = factory();
})(this, function() {
return 